import * as actions from "../action.constants";

const requestSims = (pageUrl) => ({
  type: actions.REQUEST_SIMS,
  pageUrl,
});

const createSim = (requestPayload) => ({
  type: actions.CREATE_SIM,
  requestPayload,
});

const deleteSimData = (id, callback) => ({
  type: actions.REQUEST_DELETE_SIM_SAGA,
  payload: id,
  callback,
});

const suspendSim = (id, callback) => ({
  type: actions.REQUEST_SUSPEND_SIM_SAGA,
  payload: id,
  callback,
});

const activateSim = (id, callback) => ({
  type: actions.REQUEST_ACTIVATE_SIM_SAGA,
  payload: id,
  callback,
});

const deactivateSim = (id, callback) => ({
  type: actions.REQUEST_DEACTIVATE_SIM_SAGA,
  payload: id,
  callback,
});

const updateAddsimModalData = (data) => ({
  type: actions.SAVE_ADD_SIM_MODAL_DATA,
  payload: data,
});

const updateAddsimModal = (data) => ({
  type: actions.SAVE_ADD_SIM_MODAL_STATUS,
  payload: data,
});
const sendEditSimModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_EDIT_SIM_DATA_SAGA,
  payload: data,
  callback,
});
const sendAddsimModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_ADD_SIM_DATA_SAGA,
  payload: data,
  callback,
});

const getSimUsageDetails = (data) => ({
  type: actions.REQUEST_SIM_USAGE_DETAILS_SAGA,
  payload: data,
});

const saveSimUsageDetails = (data) => ({
  type: actions.SAVE_SIM_USAGE_DETAILS,
  payload: data,
});

const saveSims = (responsePayload) => ({
  type: actions.SAVE_SIMS_LIST,
  responsePayload,
});

export {
  requestSims,
  activateSim,
  deactivateSim,
  suspendSim,
  createSim,
  deleteSimData,
  updateAddsimModalData,
  updateAddsimModal,
  sendEditSimModalData,
  sendAddsimModalData,
  getSimUsageDetails,
  saveSimUsageDetails,
  saveSims,
};
